import React from "react";
import { array, object, string } from "prop-types";
import { LoadMoreStoriesBase } from "@quintype/components";
import { connect } from "react-redux";

import LoadMoreTemplateForSearch from "./LoadMoreTemplateForSearch";

import { getFilterSections } from "../../utils/utils";
import { storyFields } from "../../utils/constant";

const SearchStories1AdWithLoadMore = ({ data = {}, lang = "bn", sections, domainSlug }) => {
  const omitQuery = (query) => {
    if (query.type === "all") delete query.type;
    if (query.sort === "default") delete query.sort;

    const sort = query.sort ? query.sort : query.q ? undefined : "latest-published";

    const sectionIds = query["section-id"]
      ? query["section-id"]
      : getFilterSections(sections, domainSlug)
          ?.map(({ id }) => id)
          ?.toString();

    return {
      "section-id": sectionIds,
      ...query,
      ...(sort ? { sort } : {}),
    };
  };

  return (
    <LoadMoreStoriesBase
      template={({ ...ops }) => <LoadMoreTemplateForSearch lang={lang} {...ops} />}
      data={data}
      fields={storyFields}
      api="/api/v1/advanced-search"
      numStoriesToLoad={10}
      params={omitQuery({ ...data.query })}
      apiResponseTransformer={({ items }) => items}
    />
  );
};

SearchStories1AdWithLoadMore.propTypes = {
  data: object,
  lang: string,
  sections: array,
  domainSlug: string,
};

const mapStateToProps = (state) => ({
  sections: state.qt.config.sections,
  domainSlug: state.qt.config.domainSlug,
});

export default connect(mapStateToProps)(SearchStories1AdWithLoadMore);
